import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { MutableRefObject, ReactNode, useEffect } from 'react';

interface DropdownMenuOptionProps {
  title: ReactNode;
  onClick: () => Promise<void>;
  className?: string;
}
interface DropdownMenuProps {
  options: DropdownMenuOptionProps[];
  triggerRef: MutableRefObject<HTMLElement>;
  positioningClassName?: string;
}
const DropdownMenu = (props: DropdownMenuProps) => {
  const [isProfileMenuOpen, setIsProfileMenuOpen] = React.useState(false);
  const profileMenuRef = React.useRef<HTMLDivElement>(null);
  const [optionIndexInProgress, setOptionIndexInProgress] = React.useState<
    number | undefined
  >(undefined);

  useEffect(() => {
    console.log('Dropdown Menu mounted', {
      triggerRef: props.triggerRef.current,
    });

    props.triggerRef.current?.addEventListener('click', handleClickTrigger);

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      props.triggerRef.current?.removeEventListener(
        'click',
        handleClickTrigger,
      );
    };

    function handleClickTrigger(event: MouseEvent) {
      if (
        props.triggerRef.current &&
        props.triggerRef.current.contains(event.target as Node)
      ) {
        setIsProfileMenuOpen((prev) => !prev);
      }
    }
    function handleClickOutside(event: MouseEvent) {
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target as Node) &&
        props.triggerRef?.current &&
        !props.triggerRef?.current.contains(event.target as Node)
      ) {
        setIsProfileMenuOpen(false);
      }
    }
  }, [props.triggerRef?.current]);

  if (!isProfileMenuOpen) return null;

  return (
    <>
      <div
        ref={profileMenuRef}
        className={`absolute mt-2 w-48 bg-white rounded-md shadow-lg z-20 overflow-hidden ${props.positioningClassName ?? 'right-0'}`}
      >
        {props.options.map((option, index) => (
          <button
            key={index}
            type="button"
            className={`block px-4 py-2 text-gray-800 ${!!optionIndexInProgress ? 'opacity-50' : ''} hover:bg-gray-200 w-full text-left ${option.className}`}
            disabled={!!optionIndexInProgress}
            onClick={async () => {
              setOptionIndexInProgress(index);
              try {
                await option.onClick();
              } finally {
                setOptionIndexInProgress(undefined);
              }
              setIsProfileMenuOpen(false);
            }}
          >
            {option.title}{' '}
            {optionIndexInProgress === index && (
              <FontAwesomeIcon icon={faSpinner} className="ml-2 animate-spin" />
            )}
          </button>
        ))}
      </div>
    </>
  );
};

export default DropdownMenu;
